var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"profile-page"},[_c('profile-header'),_c('profile-nav'),_c('div',{staticClass:"container profile-container"},[_c('transition',{attrs:{"name":"default"}},[_c('router-view')],1)],1)],1):_c('profile-sceleton')}
var staticRenderFns = []

export { render, staticRenderFns }